import { Directive, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appNoPaste]'
})
export class NoPasteDirective {

  constructor(public toast: ToastrService) { }

  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    this.toast.warning('Pasting directly into the SSN field is not permitted.', '')
    e.preventDefault();
  }

}
